var React = require('react');

function Power (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.5351 5.25684C15.5313 6.25338 16.2096 7.52294 16.4844 8.90499C16.7591 10.287 16.6179 11.7195 16.0785 13.0213C15.5392 14.3231 14.6259 15.4357 13.4543 16.2185C12.2826 17.0013 10.9052 17.4192 9.4961 17.4192C8.087 17.4192 6.70955 17.0013 5.5379 16.2185C4.36625 15.4357 3.45302 14.3231 2.91368 13.0213C2.37434 11.7195 2.2331 10.287 2.50783 8.90499C2.78256 7.52294 3.46092 6.25338 4.45714 5.25684","stroke":"#375542","strokeWidth":"1.58333","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9.5 1.58398V9.50065","stroke":"#375542","strokeWidth":"1.58333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Power.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};

module.exports = Power;

Power.default = Power;
